/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicLabradorAdTemplate, DynamicLabradorAdTemplateProps } from './AdTemplate';
import { DynamicLabradorAdunit, DynamicLabradorAdunitProps } from './Adunit';
import { DynamicLabradorAffiliateGallery, DynamicLabradorAffiliateGalleryProps } from './AffiliateGallery';
import { DynamicLabradorAffiliateItem, DynamicLabradorAffiliateItemProps } from './AffiliateItem';
import { DynamicLabradorArticle, DynamicLabradorArticleProps } from './Article';
import { DynamicLabradorArticleFooter, DynamicLabradorArticleFooterProps } from './ArticleFooter';
import { DynamicLabradorArticleHeader, DynamicLabradorArticleHeaderProps } from './ArticleHeader';
import { DynamicLabradorArticleSlider, DynamicLabradorArticleSliderProps } from './ArticleSlider';
import { DynamicLabradorArticleTeaserBodytext, DynamicLabradorArticleTeaserBodytextProps } from './ArticleTeaser/Bodytext';
import { DynamicLabradorArticleTeaserDefault, DynamicLabradorArticleTeaserDefaultProps } from './ArticleTeaser/Default';
import { DynamicLabradorArticleTeaser, DynamicLabradorArticleTeaserProps } from './ArticleTeaser';
import { DynamicLabradorBanner, DynamicLabradorBannerProps } from './Banner';
import { DynamicLabradorBlogSlider, DynamicLabradorBlogSliderProps } from './BlogSlider';
import { DynamicLabradorBodytext, DynamicLabradorBodytextProps } from './Bodytext';
import { DynamicLabradorBox, DynamicLabradorBoxProps } from './Box';
import { DynamicLabradorBreakingNews, DynamicLabradorBreakingNewsProps } from './BreakingNews';
import { DynamicLabradorByline, DynamicLabradorBylineProps } from './Byline';
import { DynamicLabradorBylineGroup, DynamicLabradorBylineGroupProps } from './BylineGroup';
import { DynamicLabradorCheckbox, DynamicLabradorCheckboxProps } from './Checkbox';
import { DynamicLabradorColumns, DynamicLabradorColumnsProps } from './Columns';
import { DynamicLabradorContentLock, DynamicLabradorContentLockProps } from './ContentLock';
import { DynamicLabradorCoverBox, DynamicLabradorCoverBoxProps } from './CoverBox';
import { DynamicLabradorFacebook, DynamicLabradorFacebookProps } from './Facebook';
import { DynamicLabradorFactbox, DynamicLabradorFactboxProps } from './Factbox';
import { DynamicLabradorFallback, DynamicLabradorFallbackProps } from './Fallback';
import { DynamicLabradorFront, DynamicLabradorFrontProps } from './Front';
import { DynamicLabradorHeading, DynamicLabradorHeadingProps } from './Heading';
import { DynamicLabradorImage, DynamicLabradorImageProps } from './Image';
import { DynamicLabradorInstagram, DynamicLabradorInstagramProps } from './Instagram';
import { DynamicLabradorJwVideoArticle, DynamicLabradorJwVideoArticleProps } from './JwVideo/Article';
import { DynamicLabradorJwVideoShoppable, DynamicLabradorJwVideoShoppableProps } from './JwVideo/Shoppable';
import { DynamicLabradorJwVideoTeaser, DynamicLabradorJwVideoTeaserProps } from './JwVideo/Teaser';
import { DynamicLabradorJwVideo, DynamicLabradorJwVideoProps } from './JwVideo';
import { DynamicLabradorLabradorImage, DynamicLabradorLabradorImageProps } from './LabradorImage';
import { DynamicLabradorList, DynamicLabradorListProps } from './List';
import { DynamicLabradorMarkup, DynamicLabradorMarkupProps } from './Markup';
import { DynamicLabradorMostRead, DynamicLabradorMostReadProps } from './MostRead';
import { DynamicLabradorNewsletterSignup, DynamicLabradorNewsletterSignupProps } from './NewsletterSignup';
import { DynamicLabradorParagraph, DynamicLabradorParagraphProps } from './Paragraph';
import { DynamicLabradorQuotebox, DynamicLabradorQuoteboxProps } from './Quotebox';
import { DynamicLabradorRadioButton, DynamicLabradorRadioButtonProps } from './RadioButton';
import { DynamicLabradorRecommendedArticles, DynamicLabradorRecommendedArticlesProps } from './RecommendedArticles';
import { DynamicLabradorRichtextbox, DynamicLabradorRichtextboxProps } from './Richtextbox';
import { DynamicLabradorRow, DynamicLabradorRowProps } from './Row';
import { DynamicLabradorSavedArticles, DynamicLabradorSavedArticlesProps } from './SavedArticles';
import { DynamicLabradorSecondNativeArticle, DynamicLabradorSecondNativeArticleProps } from './SecondNativeArticle';
import { DynamicLabradorShowsSlider, DynamicLabradorShowsSliderProps } from './ShowsSlider';
import { DynamicLabradorSlider, DynamicLabradorSliderProps } from './Slider';
import { DynamicLabradorTagsIndex, DynamicLabradorTagsIndexProps } from './TagsIndex';
import { DynamicLabradorTextMultiline, DynamicLabradorTextMultilineProps } from './TextMultiline';
import { DynamicLabradorTextSubtitle, DynamicLabradorTextSubtitleProps } from './TextSubtitle';
import { DynamicLabradorTextTitle, DynamicLabradorTextTitleProps } from './TextTitle';
import { DynamicLabradorTiktok, DynamicLabradorTiktokProps } from './Tiktok';
import { DynamicLabradorTrendingMenu, DynamicLabradorTrendingMenuProps } from './TrendingMenu';
import { DynamicLabradorTwitter, DynamicLabradorTwitterProps } from './Twitter';
import { DynamicLabradorVideoReels, DynamicLabradorVideoReelsProps } from './VideoReels';
import { DynamicLabradorYouplay, DynamicLabradorYouplayProps } from './Youplay';
import { DynamicLabradorYoutube, DynamicLabradorYoutubeProps } from './Youtube';

export type DynamicLabradorComponentsProps = {
  AdTemplate: DynamicLabradorAdTemplateProps;
  Adunit: DynamicLabradorAdunitProps;
  AffiliateGallery: DynamicLabradorAffiliateGalleryProps;
  AffiliateItem: DynamicLabradorAffiliateItemProps;
  Article: DynamicLabradorArticleProps;
  ArticleFooter: DynamicLabradorArticleFooterProps;
  ArticleHeader: DynamicLabradorArticleHeaderProps;
  ArticleSlider: DynamicLabradorArticleSliderProps;
  ArticleTeaserBodytext: DynamicLabradorArticleTeaserBodytextProps;
  ArticleTeaserDefault: DynamicLabradorArticleTeaserDefaultProps;
  ArticleTeaser: DynamicLabradorArticleTeaserProps;
  Banner: DynamicLabradorBannerProps;
  BlogSlider: DynamicLabradorBlogSliderProps;
  Bodytext: DynamicLabradorBodytextProps;
  Box: DynamicLabradorBoxProps;
  BreakingNews: DynamicLabradorBreakingNewsProps;
  Byline: DynamicLabradorBylineProps;
  BylineGroup: DynamicLabradorBylineGroupProps;
  Checkbox: DynamicLabradorCheckboxProps;
  Columns: DynamicLabradorColumnsProps;
  ContentLock: DynamicLabradorContentLockProps;
  CoverBox: DynamicLabradorCoverBoxProps;
  Facebook: DynamicLabradorFacebookProps;
  Factbox: DynamicLabradorFactboxProps;
  Fallback: DynamicLabradorFallbackProps;
  Front: DynamicLabradorFrontProps;
  Heading: DynamicLabradorHeadingProps;
  Image: DynamicLabradorImageProps;
  Instagram: DynamicLabradorInstagramProps;
  JwVideoArticle: DynamicLabradorJwVideoArticleProps;
  JwVideoShoppable: DynamicLabradorJwVideoShoppableProps;
  JwVideoTeaser: DynamicLabradorJwVideoTeaserProps;
  JwVideo: DynamicLabradorJwVideoProps;
  LabradorImage: DynamicLabradorLabradorImageProps;
  List: DynamicLabradorListProps;
  Markup: DynamicLabradorMarkupProps;
  MostRead: DynamicLabradorMostReadProps;
  NewsletterSignup: DynamicLabradorNewsletterSignupProps;
  Paragraph: DynamicLabradorParagraphProps;
  Quotebox: DynamicLabradorQuoteboxProps;
  RadioButton: DynamicLabradorRadioButtonProps;
  RecommendedArticles: DynamicLabradorRecommendedArticlesProps;
  Richtextbox: DynamicLabradorRichtextboxProps;
  Row: DynamicLabradorRowProps;
  SavedArticles: DynamicLabradorSavedArticlesProps;
  SecondNativeArticle: DynamicLabradorSecondNativeArticleProps;
  ShowsSlider: DynamicLabradorShowsSliderProps;
  Slider: DynamicLabradorSliderProps;
  TagsIndex: DynamicLabradorTagsIndexProps;
  TextMultiline: DynamicLabradorTextMultilineProps;
  TextSubtitle: DynamicLabradorTextSubtitleProps;
  TextTitle: DynamicLabradorTextTitleProps;
  Tiktok: DynamicLabradorTiktokProps;
  TrendingMenu: DynamicLabradorTrendingMenuProps;
  Twitter: DynamicLabradorTwitterProps;
  VideoReels: DynamicLabradorVideoReelsProps;
  Youplay: DynamicLabradorYouplayProps;
  Youtube: DynamicLabradorYoutubeProps;
}

export const DynamicLabradorComponents = {
  AdTemplate: DynamicLabradorAdTemplate,
  Adunit: DynamicLabradorAdunit,
  AffiliateGallery: DynamicLabradorAffiliateGallery,
  AffiliateItem: DynamicLabradorAffiliateItem,
  Article: DynamicLabradorArticle,
  ArticleFooter: DynamicLabradorArticleFooter,
  ArticleHeader: DynamicLabradorArticleHeader,
  ArticleSlider: DynamicLabradorArticleSlider,
  ArticleTeaserBodytext: DynamicLabradorArticleTeaserBodytext,
  ArticleTeaserDefault: DynamicLabradorArticleTeaserDefault,
  ArticleTeaser: DynamicLabradorArticleTeaser,
  Banner: DynamicLabradorBanner,
  BlogSlider: DynamicLabradorBlogSlider,
  Bodytext: DynamicLabradorBodytext,
  Box: DynamicLabradorBox,
  BreakingNews: DynamicLabradorBreakingNews,
  Byline: DynamicLabradorByline,
  BylineGroup: DynamicLabradorBylineGroup,
  Checkbox: DynamicLabradorCheckbox,
  Columns: DynamicLabradorColumns,
  ContentLock: DynamicLabradorContentLock,
  CoverBox: DynamicLabradorCoverBox,
  Facebook: DynamicLabradorFacebook,
  Factbox: DynamicLabradorFactbox,
  Fallback: DynamicLabradorFallback,
  Front: DynamicLabradorFront,
  Heading: DynamicLabradorHeading,
  Image: DynamicLabradorImage,
  Instagram: DynamicLabradorInstagram,
  JwVideoArticle: DynamicLabradorJwVideoArticle,
  JwVideoShoppable: DynamicLabradorJwVideoShoppable,
  JwVideoTeaser: DynamicLabradorJwVideoTeaser,
  JwVideo: DynamicLabradorJwVideo,
  LabradorImage: DynamicLabradorLabradorImage,
  List: DynamicLabradorList,
  Markup: DynamicLabradorMarkup,
  MostRead: DynamicLabradorMostRead,
  NewsletterSignup: DynamicLabradorNewsletterSignup,
  Paragraph: DynamicLabradorParagraph,
  Quotebox: DynamicLabradorQuotebox,
  RadioButton: DynamicLabradorRadioButton,
  RecommendedArticles: DynamicLabradorRecommendedArticles,
  Richtextbox: DynamicLabradorRichtextbox,
  Row: DynamicLabradorRow,
  SavedArticles: DynamicLabradorSavedArticles,
  SecondNativeArticle: DynamicLabradorSecondNativeArticle,
  ShowsSlider: DynamicLabradorShowsSlider,
  Slider: DynamicLabradorSlider,
  TagsIndex: DynamicLabradorTagsIndex,
  TextMultiline: DynamicLabradorTextMultiline,
  TextSubtitle: DynamicLabradorTextSubtitle,
  TextTitle: DynamicLabradorTextTitle,
  Tiktok: DynamicLabradorTiktok,
  TrendingMenu: DynamicLabradorTrendingMenu,
  Twitter: DynamicLabradorTwitter,
  VideoReels: DynamicLabradorVideoReels,
  Youplay: DynamicLabradorYouplay,
  Youtube: DynamicLabradorYoutube,
}
